module.exports = __webpack_public_path__ + "img/SKMJ_cap1.374c92a5.jpg";